<template>
  <div class="ml-1 mr-1" :class="{ hidden: !visible }" ref="root">
    <v-sheet
      v-if="visible"
      elevation="3"
      class="py-1 px-1 pr-2 tile"
      :class="{
        'tile-mine': belongsToMe,
        invalid: isInvalid
      }"
      @click.native="redirectToNew"
      :tooltip="tooltip"
    >
      <v-layout row class="mb-1">
        <v-flex
          xs12
          class="d-flex align-start justify-space-between d-flex-initial"
        >
          <div class="d-flex">
            {{ head }}
            <div class="state">{{ state }}</div>
          </div>

          <v-layout column align-end>
            <v-chip
              v-for="tag in prospect.tags"
              :key="tag"
              small
              class="tag-chip"
            >
              {{ tag }}
            </v-chip>
          </v-layout>

          <div v-if="notifications.length > 0">
            <v-icon
              size="18px"
              class="mr-0"
              color="accent"
              title="Notifications"
              >whatshot</v-icon
            >
          </div>
        </v-flex>
      </v-layout>
      <v-layout row v-for="alert in prospect.alerts" :key="alert">
        <v-flex xs12 class="alert">{{ alert }}</v-flex>
      </v-layout>

      <v-layout row justify-space-between style="font-size: 12px">
        <v-flex xs5 class="d-flex align-center d-flex-initial">
          <v-icon class="mr-1" size="13px">assignment_ind</v-icon>
          <div class="mr-1">{{ prospect.assignees.lead || "???" }}</div>
          <v-icon class="mr-1" size="13px">work</v-icon>
          <div class="mr-1">{{ prospect.assignees.sale || "???" }}</div>
        </v-flex>
        <v-flex xs4 class="d-flex align-center justify-end d-flex-initial">
          <v-icon
            color="brown"
            size="13px"
            class="mr-1"
            v-if="prospect.notInterested || prospect.progress.stopped"
            >clear</v-icon
          >
          <v-icon class="mr-1" size="13px" title="Dernier mouvement"
            >history</v-icon
          >
          {{ lastDate | date }}
        </v-flex>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { ALL_PROSPECTS_COLUMNS, PROSPECT_ORDER } from "../data/DefaultSettings";

export default {
  name: "ProjectTile",
  data() {
    return {
      visible: false
    };
  },
  props: ["prospect"],
  timers: {
    refreshVisibility: { time: 500, autostart: true, repeat: true }
  },
  computed: {
    ...mapState("notifications", {
      allNotifs: p => p.all
    }),
    ...mapState("user", ["trigram"]),
    ...mapGetters("user", ["isAdminOrSuperAdmin"]),
    state() {
      return ALL_PROSPECTS_COLUMNS.find(
        p => p.value === this.prospect.currentProgress
      )?.text;
    },
    isInvalid() {
      const currentIdx = PROSPECT_ORDER.indexOf(this.prospect.currentProgress);
      const theoreticalIdx = PROSPECT_ORDER.indexOf(
        this.prospect.theoreticalStatus
      );
      return currentIdx > theoreticalIdx;
    },
    tooltip() {
      return this.isInvalid &&
        this.prospect.currentProgress === "done" &&
        this.prospect.theoreticalStatus === "involved"
        ? "Aucun dossier associé à ce prospect"
        : null;
    },
    lastDate() {
      return this.prospect.progress[this.prospect.currentProgress];
    },
    head() {
      return this.prospect.name;
    },
    notifications() {
      return this.allNotifs.filter(
        ({ idProject, seen }) => !seen && idProject === this.prospect._id
      );
    },
    belongsToMe() {
      return (
        this.isAdminOrSuperAdmin ||
        this.trigram === this.prospect.assignees.sale ||
        this.trigram === this.prospect.assignees.lead
      );
    }
  },
  methods: {
    refreshVisibility() {
      const rect = this.$refs.root.getBoundingClientRect();
      const ww = document.documentElement.clientWidth;
      const wh = document.documentElement.clientHeight;

      this.visible = !(
        rect.right < 0 ||
        rect.bottom < 0 ||
        rect.left > ww ||
        rect.top > wh
      );
    },
    redirectToNew() {
      if (this.belongsToMe) {
        this.$router.push(`/prospect/${this.prospect._id}`);
      }
    }
  }
};
</script>

<style scoped>
.tile-mine {
  cursor: pointer;
}

.tile {
  margin: 0 0 0 5px;
  min-width: 240px;
  opacity: 1;
  transition: opacity ease-in 300ms, height ease-in 300ms;
}

.invalid {
  background-color: #e30000;
}

.alert {
  font-size: 9px;
  background: #ff7c5d;
  border-radius: 3px;
  padding: 2px 5px;
  margin-right: 8px;
  margin-bottom: 8px;
  color: white;
}

.hidden {
  background: white;
  height: 50px;
  opacity: 0.3;
  min-width: 240px;
}

.state {
  display: none;
}

.tag-chip {
  max-width: 100%;
}

.tag-chip >>> .v-chip__content {
  max-width: 100%;
  display: inline-block;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 450px) {
  .state {
    display: block;
    background-color: lightblue;
    border-radius: 9px;
    font-size: 11px;
    padding: 3px 5px 3px 5px;
    margin-left: 20px;
  }
}
</style>
